// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-2b951a4c]{display:flex;align-items:stretch;width:100%}#content[data-v-2b951a4c]{width:100%;min-height:100vh;transition:all .3s}nav[data-v-2b951a4c]{background-color:hsla(0,0%,100%,.96);border-bottom:1px solid rgba(0,0,0,.1)}.main-content[data-v-2b951a4c]{padding:30px 15px;height:calc(100vh - 65px);overflow:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
